exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3df5fc28] .md-checkbox-label {\n  opacity: 1 !important;\n  color: black !important;\n}\n[data-v-3df5fc28] div.md-field.no-underline:after {\n  height: 0px;\n}\n[data-v-3df5fc28] .md-checkbox {\n  margin-top: 0px;\n}\n.md-field.checkbox-container[data-v-3df5fc28] {\n  padding-bottom: 0;\n  margin: 0;\n}\n.md-field.checkbox-container[data-v-3df5fc28]:after {\n  height: 0;\n}\n", ""]);

// exports
